import { call, put, takeEvery, select } from "redux-saga/effects";

import { callApi } from "../../api/Api";

import {
  stopLoading,
  showErrorMessage,
  startLoading,
} from "../layout/action";
import {FETCH_VEHICLE_REQUIRED_FIELD,setVehicleRequiredFiled } from "./action";

export function* callVehicleRequiredFields(action) {
  try {
    const { loginState } = yield select();
    const { userContext } = loginState;
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      method: "GET",
      url: `/optional-properties/vehicles/${action.payload}`,
    });

    const { data } = stateResponse;
    yield put(setVehicleRequiredFiled(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Vehicle Required Fields" }));
  }
}

export function* watchVehicleRequiredFields() {
  yield takeEvery(FETCH_VEHICLE_REQUIRED_FIELD, callVehicleRequiredFields);
}

